import { internalFetch } from '../utils/fetchHelper';
import { ITenant } from './tenantService';

export interface authorizeRequest {
  username: string;
}

export interface authorizeResponse {
  token: string;
  permissions: number[];
  tenants: ITenant[];
  currentTenant: number;
}

export const authorize = async (
  abortController: AbortController,
  payload: authorizeRequest
): Promise<authorizeResponse> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/a/authorize?code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'POST',
    abortController,
    JSON.stringify(payload),
    undefined,
    3
  );
};
